/**
 * Scheduler filter dropdown — a uniform, compact SearchableSelect used for
 * every Scheduler filter (provider, mode, status, country, tag) so they all
 * share one height and width.
 * For Media Devoted | Created By Ciro Autiero
 */

import { SearchableSelect, type SearchableSelectOption } from '@/components/ui';

export interface FilterSelectProps {
  options: SearchableSelectOption<string>[];
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
}

export function FilterSelect({
  options,
  value,
  onChange,
  placeholder,
}: FilterSelectProps) {
  return (
    <SearchableSelect
      options={options}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      className="h-9 w-40"
    />
  );
}
